import { SideModal, SVG } from "shared";
import "./AnalyzeInfoModal.scss";
import { AnalyzeType } from "types/AnalyzeTypes";
import { AnalyzeForm, AnalyzeTable } from "./components";
import { downloadFile } from "utils";
import { ROLES_ENUM, SVG_ENUM } from "enums";
import { useGetMe } from "hooks/auth";

interface AnalyzeInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  analyze: AnalyzeType | null;
}

const AnalyzeInfoModal: React.FC<AnalyzeInfoModalProps> = ({
  isOpen,
  onClose,
  analyze,
}) => {
  const { data: authorizedUser } = useGetMe();
  const isAdmin = authorizedUser?.role === ROLES_ENUM.ADMIN;
  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Szczegółowe informacje"
      subtitle={
        <p>
          Analiza spółki <span className="fw-600">{analyze?.companyName}</span>
        </p>
      }
      className="company-info-modal analyze-info-modal side-modal--full-height"
    >
      <div className="analyze-info-modal__content">
        <AnalyzeTable analyze={analyze} isAdmin={isAdmin} />
        {analyze?.status === "completed" ? (
          <>
            <p className="analyze-info-modal__analyze">Analiza </p>
            <p className="drop-file-input__file">
              {analyze?.file?.name}
              <span
                onClick={() =>
                  downloadFile({
                    name: analyze.file.name,
                    url: analyze.file.url,
                  })
                }
              >
                <SVG type={SVG_ENUM.FILE} />
              </span>
            </p>
          </>
        ) : isAdmin && analyze?.status !== "canceled" ? (
          <AnalyzeForm analyze={analyze} onClose={onClose} />
        ) : null}
      </div>
    </SideModal>
  );
};

export default AnalyzeInfoModal;
